import { render } from "./reporte_cotizaciones.vue?vue&type=template&id=49aa9fc4&scoped=true&lang=es"
import script from "./reporte_cotizaciones.vue?vue&type=script&lang=js"
export * from "./reporte_cotizaciones.vue?vue&type=script&lang=js"

import "./reporte_cotizaciones.vue?vue&type=style&index=0&id=49aa9fc4&scoped=true&lang=css"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49aa9fc4"]])

export default __exports__